// Cloudinary signed upload helper.
//
// The browser holds no credential that can write to Cloudinary. Every upload
// asks the Worker for a one-time signature first; the Worker checks who is
// calling, decides where the file may land, names the file, and returns the
// exact set of parameters to send. We forward that set verbatim — adding or
// changing one here would break the signature, which is the point.
window.CloudinaryUpload = {
  MAX_BYTES: 10 * 1024 * 1024,
  ALLOWED: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/heic', 'image/heif', 'image/gif'],

  sign: async function (folder) {
    const config = window.TALISNAILZ || {};
    if (!config.workerUrl || !config.customerId) {
      throw new Error('Sign in to upload photos.');
    }

    const res = await fetch(config.workerUrl.replace(/\/+$/, '') + '/api/upload/sign', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customerId: String(config.customerId),
        ts: config.authTs,
        sig: config.authSig,
        folder: folder || 'talisnailz',
        v: 2
      })
    });

    const data = await res.json().catch(() => null);
    if (!res.ok || !data || !data.ok) {
      throw new Error((data && data.error) || 'Upload not authorised.');
    }
    return data;
  },

  upload: async function (file, onProgress, folder) {
    if (!file) throw new Error('No file selected.');
    if (this.ALLOWED.indexOf(file.type) === -1) throw new Error('That file type is not supported.');
    if (file.size > this.MAX_BYTES) throw new Error('That photo is over 10MB.');

    const s = await this.sign(folder);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('api_key', s.apiKey);
    const params = s.params || { folder: s.folder, public_id: s.publicId, timestamp: s.timestamp };
    Object.keys(params).forEach(function (k) { formData.append(k, params[k]); });
    formData.append('signature', s.signature);

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + s.cloudName + '/image/upload');

      if (onProgress) {
        xhr.upload.addEventListener('progress', e => {
          if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
        });
      }

      xhr.onload = () => {
        if (xhr.status === 200) {
          const data = JSON.parse(xhr.responseText);
          resolve({ url: data.secure_url, publicId: data.public_id, width: data.width, height: data.height });
        } else {
          reject(new Error('Upload failed: ' + xhr.statusText));
        }
      };

      xhr.onerror = () => reject(new Error('Network error during upload'));
      xhr.send(formData);
    });
  },

  uploadMultiple: async function (files, onEach) {
    const results = [];
    for (const file of files) {
      const result = await this.upload(file, onEach ? (pct) => onEach(file.name, pct) : null);
      results.push(result);
    }
    return results;
  }
};